import styled from 'styled-components';

export const AppContainer = styled.div`
  width: 100%;
  padding: 24px;
  max-width: 1600px;

  ${(props) => props.theme.media.sm.max`
    padding: 0px;
    position: relative;
    height: calc(100vh);
  `}
`;

export const AuthContain = styled.div`
  height: 100%;

  ${(props) => props.theme.media.sm.max`
    position: relative;
    top: 88px;
  `}
`;
